
export const roles = {
    Administrator: "1",
    Reporter: "2",
    NormalUser: "3"
};
